import _typeof from "@babel/runtime/helpers/typeof";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import { Spinner } from 'components';
import { removeImageAdImage, uploadImages } from 'redux/modules/adBuilder';

function ImageUploadSection(props) {
  var multiple = props.multiple,
      video = props.video,
      onChange = props.onChange,
      adImage = props.adImage,
      uploadingFile = props.uploadingFile,
      upload = props.uploadImages,
      remove = props.removeImageAdImage,
      organization = props.organization;

  var handleDrop = function handleDrop(files) {
    if (files && files.length > 0) {
      upload(files, organization.id).then(function (result) {
        var newItems = _toConsumableArray(result.data);

        if (onChange) {
          onChange(newItems.map(function (item) {
            return item.fullyQualifiedUrl;
          }));
        }
      })["catch"](function (err) {
        console.error(err);
      });
    }
  };

  var dropzone = /*#__PURE__*/React.createElement(Dropzone, {
    multiple: multiple,
    onDrop: handleDrop,
    accept: !video ? 'image/*' : 'video/mp4,video/x-m4v,video/*',
    style: {
      width: 120,
      height: 120,
      borderColor: '#8b8b8b',
      borderRadius: 4,
      border: '1px dashed #8b8b8b'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      position: 'relative',
      top: '25%',
      color: '#8b8b8b',
      fontSize: 13,
      padding: 8
    }
  }, "Drag and drop a", !video ? 'n image' : ' video', " here or click to upload."));
  var renderedAdImage = adImage ? adImage.map(function (item, idx) {
    var url = _typeof(item) === 'object' ? item.fullyQualifiedUrl : item;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'relative'
      },
      key: idx
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: 'center',
        backgroundColor: '#fff',
        borderWidth: 1,
        borderColor: '#8b8b8b',
        borderStyle: 'solid',
        position: 'absolute',
        top: '-10px',
        left: '-10px',
        width: 25,
        height: 25,
        lineHeight: '25px',
        borderRadius: '50%',
        display: 'inline-block',
        cursor: 'pointer'
      },
      onClick: function onClick() {
        remove(organization.id);

        if (onChange) {
          onChange([]);
        }
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "icon ion-ios-close-empty",
      style: {
        color: '#8b8b8b',
        fontSize: 25,
        lineHeight: '24px',
        width: '100%',
        display: 'inline-block',
        textAlign: 'center'
      }
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        backgroundImage: "url(".concat(url, ")"),
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        display: 'inline-block',
        marginRight: 16,
        width: props.width,
        height: props.height,
        cursor: 'pointer',
        borderColor: '#DBDBDB',
        borderWidth: '0.5px',
        borderStyle: 'solid',
        borderRadius: '4px'
      }
    }));
  }) : /*#__PURE__*/React.createElement("span", null);
  var dropzoneRender = dropzone;

  if (adImage && adImage.length) {
    dropzoneRender = '';
  } else if (uploadingFile) {
    dropzoneRender = /*#__PURE__*/React.createElement(Spinner, {
      center: true
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: props.height,
      position: 'relative'
    }
  }, renderedAdImage, dropzoneRender);
}

function mapStateToProps(state) {
  var orgId = state.organization.current.id;
  return {
    adImage: state.adBuilder["".concat(orgId)] && state.adBuilder["".concat(orgId)].adImage ? state.adBuilder["".concat(orgId)].adImage : [],
    uploadingFile: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].uploadingFile : false,
    organization: state.organization.current
  };
}

ImageUploadSection.propTypes = {
  multiple: PropTypes.bool.isRequired,
  video: PropTypes.bool.isRequired,
  adImage: PropTypes.array.isRequired,
  removeImageAdImage: PropTypes.func.isRequired,
  uploadImages: PropTypes.func.isRequired,
  uploadingFile: PropTypes.bool.isRequired
};
var actionCreators = {
  removeImageAdImage: removeImageAdImage,
  uploadImages: uploadImages
};
ImageUploadSection.defaultProps = {
  height: 120,
  width: 120
};
export default connect(mapStateToProps, actionCreators)(ImageUploadSection);